import React from 'react';
import './styles.scss';

const Slider = ({ style, step, min, max, value, onChange, onRelease }) => {
  return (
    <input
      type="range"
      onChange={onChange}
      min={min}
      max={max}
      value={value}
      style={style}
      step={step}
      onMouseUp={onRelease}
      onTouchEnd={onRelease}
      className="slider"
    />
  );
};

export default Slider;
